export default __webpack_public_path__ + "static/media/video-image.eca79450.jpg";